import { SEARCH_QUERY_PARAMETER_NAME } from 'config/constants';
import { getQueryWithoutSlugTypeParameterFromParsedUrlQuery } from 'helpers/parsing/urlParsing';
import { useRouter } from 'next/router';
import { UrlQueries } from 'types/urlQueries';

export const useCurrentSearchStringQuery = () => {
    const router = useRouter();
    const query = getQueryWithoutSlugTypeParameterFromParsedUrlQuery(router.query) as UrlQueries;
    const searchStringQuery = query[SEARCH_QUERY_PARAMETER_NAME];

    return searchStringQuery;
};
